import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment-timezone";
import { Link } from "react-router-dom";

export const StyledCell = styled.div`
  display: flex;
  padding: 12px;
  font-family: "Montserrat";
  min-height: 100%;
  font-style: normal;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  /* word-break: break-all; */
  word-break: break-word;

  ${({ width }) =>
    width
      ? css`
          min-width: ${width}px;
          width: ${width}px;
          min-width: ${width}px;
          max-width: ${width}px;
        `
      : css`
          margin-right: auto;
        `}

  ${({ minWidthCell }) =>
    minWidthCell &&
    css`
      min-width: ${minWidthCell}px;
    `}

  ${({ fontSize }) =>
    fontSize === "bold" &&
    css`
      font-family: "Montserrat";
    `}

  ${({ textAlign }) =>
    textAlign &&
    css`
      justify-content: ${textAlign};
    `};

  ${({ bold }) =>
    bold &&
    css`
      font-weight: bold;
    `};

  ${({ multiline }) =>
    multiline &&
    css`
      flex-direction: column;
    `};

  ${({ adaptive }) =>
    adaptive &&
    css`
      @media (max-width: 1090px) {
        min-width: 160px;
        max-width: 160px;
        margin-right: 0;
      }
    `}
`;
const ButtonCell = styled(StyledCell)`
  cursor: pointer;
`;
const DateCell = styled(StyledCell)`
  text-transform: uppercase;
`;
const ActiveText = styled.span`
  font-weight: bold;

  ${({ children }) =>
    children === "ACTIVE" &&
    css`
      color: green;
    `}

  ${({ children }) =>
    children === "CANCELLED" &&
    css`
      color: red;
    `}
`;

const LinkText = styled(Link)`
  font-size: 13px;
  color: #03589c;
`;

function OptionalButton({ onClick, element: Component, ...props }) {
  return (
    <ButtonCell onClick={() => onClick(props)} {...props}>
      <Component />
    </ButtonCell>
  );
}

OptionalButton.propTypes = {
  onClick: PropTypes.func,
  element: PropTypes.oneOfType([PropTypes.object, PropTypes.element, PropTypes.func]),
};

function Cell({ label, format, children, onClick, optional, priceFormatter, getlink, multiline, ...props }) {
  if (onClick)
    return optional ? (
      props.id && props.nextPayDate !== "null" ? (
        <OptionalButton onClick={onClick} {...props} />
      ) : (
        <StyledCell {...props} />
      )
    ) : (
      <OptionalButton onClick={onClick} {...props} />
    );

  if (format)
    return <DateCell {...props}>{children && children !== "null" ? moment(children).format(format) : "—"}</DateCell>;

  if (priceFormatter) return <StyledCell {...props}>{priceFormatter(children)}</StyledCell>;

  if (getlink)
    return (
      <StyledCell {...props}>
        {/* <LinkText to={props?.id && props?.productId ? `${props?.id}/${props?.productId}` : "#"}>{children}</LinkText> */}
        <LinkText to={getlink(props)}>{children}</LinkText>
      </StyledCell>
    );

  if (label === "Status")
    return (
      <StyledCell {...props}>
        <ActiveText>{children}</ActiveText>
      </StyledCell>
    );

  if (multiline)
    return (
      <StyledCell multiline {...props}>
        {children?.split("\n")?.map((part, idx) => (
          <div key={`revision-message-part-${idx}`}>{part}</div>
        ))}
      </StyledCell>
    );

  return <StyledCell {...props}>{children}</StyledCell>;
}

Cell.propTypes = {
  width: PropTypes.number,
  minWidthCell: PropTypes.number,
  textAlign: PropTypes.string,
  label: PropTypes.string,
  productId: PropTypes.string,
  fontSize: PropTypes.string,
  format: PropTypes.string,
  multiline: PropTypes.bool,
  nextPayDate: PropTypes.string,
  id: PropTypes.string,
  optional: PropTypes.bool,
  bold: PropTypes.bool,
  getlink: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func, PropTypes.number]),
  element: PropTypes.oneOfType([PropTypes.object, PropTypes.element, PropTypes.func]),
  priceFormatter: PropTypes.func,
};

export default Cell;
